<script>
import FactureLine from './factureLine';
import {updateMontant} from '../../../mixins/updateMontant.js';

export default {
  name: 'factureItem',
  props:{
    factureId: String,
    date: String,
    numero: String,
    lines: Array,
  },
  components:{
    FactureLine,
  },
  mixins:[
    updateMontant,
  ],
  data(){
    return {
      
    }
  },
  computed: {
    montantTotalHT(){
      let sum = 0
      for (let line of this.lines){
        sum += line.montant
      }
      return this.updateMontant(sum).str
    }
  },
  watch: {

  },
  mounted(){
    
  },
  methods:{

  }
}
</script>


<template>
  <div class="factureItem">
    <div class="factureItem__header">
        <span >Date :</span>
        <span class="factureItem__header__result"> {{date.slice(0,10)}} </span>
        <span >Facture n°</span>
        <span class="factureItem__header__result"> {{numero}} </span>
    </div>
    <FactureLine v-for="line in lines" :key="line._id" :phaseName="line.phaseName" :pourcentage="line.pourcentage" :montantHT="line.montant" :tva="line.tva" />
    <div class="factureItem__footer factureItem__grid">
        <div class="factureItem__footer__total">Total :</div>
        <div class="factureItem__footer__montant">{{montantTotalHT}}<span class="factureItem__footer__montant__unit">€<sup>ht</sup></span></div>
        <div class="factureItem__footer__icons">
            <!-- <span class="material-icons factureItem__footer__icons__icon" @click="$emit('paiement', factureId)">euro_symbol</span> -->
            <!-- <span class="material-icons factureItem__footer__icons__icon" @click="$emit('print', factureId)">print</span> -->
            <span class="material-icons factureItem__footer__icons__icon" @click="$emit('suppr', factureId)">delete_outline</span>
        </div>
    </div>      
    <!-- <span class="phaseLine__name"> {{nomPhase}} </span>
    <input type="date" class="phaseLine__date" :value="date.slice(0, 10)" @change="emitChange($event, 'date')" />
    <select v-model="labelId" @change="emitChange($event, 'typeFrais')" class="phaseLine__select">
      <option v-for="item in frais" :key="item._id" :value="item._id" > {{item.name}} </option>
    </select>
    <input type="text" placeholder="Objet" :value="objet" class="phaseLine__objet" @change="emitChange($event, 'objet')"/>
    <input type="text" :value="updateMontant(montantHT).str" class="phaseLine__montant" @change="emitChange($event, 'montantHT')"/><span class="phaseLine__text phaseLine__unit">€<sup>HT</sup></span>
    <span class="material-icons phaseLine__icon" @click="$emit('suppr', ndfId)">delete_outline</span> -->
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../assets/main.scss';

.factureItem{
    display: flex;
    flex-direction: column;
    @include myBlock;
    padding: 7px 10px;
    margin: 0 0 4px 0;

    &__header{
        display: flex;
        @include myFont;
        font-size: 13px;
        color: $black-bolder;
        margin: 0 0 10px 0;

        &__result{
            margin: 0 25px 0 3px;
            font-weight: 600;
            color: black;
        }
    }

    //Grille identique pour les lignes de facturation et pour le footer
    &__grid{
        display: grid;
        grid-template-columns: 3fr 1fr 2fr 2fr 2fr;
    }

    // &__ligne{
        
    // }

    &__footer{
        margin: 7px 0 0 0;

        &__total{
          grid-column: 2;
          justify-self: right;
          @include myFont;
          font-size: 13px;
          color: $black-bolder;
        }

        &__montant{
          grid-column: 3;
          justify-self: right;
          @include myFont;
          font-size: 13px;
          font-weight: 600;
          color: black;

          &__unit{
            margin: 0 0 0 3px;
          }
        }

        &__icons{
            grid-column: 4 / span 2;
            justify-self: right;
            
              &__icon{
                color: $mainBlack;
                font-size: 20px;
                margin: 0 0 0 10px;

                &:hover{
                cursor: pointer;
                color: $color2;
                }
            }
        }
    }

//   &__text{
//     @include myFont;
//     font-size: 13px;
//     color: $black-bolder;
//   }

//   &__name{
//     width: 150px;
//     @include myFont;
//     font-size: 13px;
//     color: $black-bolder;
//   }

//   &__date{
//     border: none;
//     width: 140px;
//     margin: 2px 5px 0 0;
//   }

//   &__select{
//     border: none;
//     width: 130px;
//   }

//   &__objet{
//     @include myField;
//     color: $black-bolder;
//     flex: 1;
//     margin: 0 20px;
//     width: 130px;
//     font-size: 13px;
//   }

//   &__montant {
//     @include myField;
//     color: $black-bolder;
//     width: 55px;
//     text-align: right;
//     font-size: 13px;
//     // padding-right: 28px;
//   }

//   &__unit{
//     margin: 0px 5px 3px 5px;
//   }

//   &__total{
//     @include myFont;
//     font-size: 13px;
//     color: $black-bolder;
//     text-align: right;
//     padding: 2px 0 0 0;
//   }




//   &__error{
//     color: $alert !important;
//     background-color: $alert-lighter;
//   }
}

</style>
